import React from 'react';

import Flex from '../Flex';

export function CardHeader({ className = '', children = null }) {
  return (
    <Flex
      gap={16}
      align="center"
      justify="space-between"
      className={className}
      data-card-element="header"
    >
      {children}
    </Flex>
  );
}
